import { render, staticRenderFns } from "./FormTalla.vue?vue&type=template&id=3b889af5&"
import script from "./FormTalla.vue?vue&type=script&lang=js&"
export * from "./FormTalla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports